import { PropertyFilterProps, SelectProps } from '@amzn/awsui-components-react';
import { getString } from 'common/ui-string-labels/ui-strings-utils';
import { VENDORS } from 'configuration/config';

export interface ProductInventoryItem {
    productTaxonomyId: string;
    productName: string;
    productSku: string;
    seatsAvailable: number;
    seatsAssigned: number;
    pendingDelivery?: number;
    hasLowInventory: boolean;
    leadTimeDays?: number | null;
    createdBy: string;
    createdDate: string;
    lastPurchasedDate?: string;
    lastReceivedDate?: string;
    lastSeatsAdded?: number;
    lastUploadedBy?: string;
    lastUploadedDate?: string;
    details?: {
        lastMonthlyOrders?: number;
        lastQuarterlyOrders?: number;
    };
    stampedNote?: {
        by: string;
        note: string;
        on: string;
        via: string;
    };
    safetyStock?: number;
    restockThreshold?: number;
    totalSeats?: number;
    needsReorder?: boolean;
}

export type EditableFields = Pick<ProductInventoryItem, 'leadTimeDays'>;

export interface ReceiveFormData {
    seatsToAdd: number | null;
    amazonPo: string;
    receivedDate: string;
    notes: string;
}

export const NEED_TO_ORDER_OPTIONS: SelectProps.Options = [
    { value: 'all', label: getString('productInventory.filter.allOrderStatus') },
    { value: 'yes', label: getString('productInventory.filter.needToOrderYes') },
];

export const VENDOR_OPTIONS: SelectProps.Options = [
    { value: 'all', label: getString('productInventory.filter.allVendors') },
    ...VENDORS.map(v => ({ value: v.id, label: v.label })),
];

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
    { key: 'product', propertyLabel: getString('productInventory.columns.product'), groupValuesLabel: getString('productInventory.columns.product'), operators: ['='] },
    { key: 'sku', propertyLabel: getString('productInventory.columns.partNumber'), groupValuesLabel: getString('productInventory.columns.partNumber'), operators: ['='] },
];
